"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _reactVirtualized = require("react-virtualized");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseTranslation = require("nicbase-translation");

var _Column = require("./Column");

var _RowRenderer = _interopRequireDefault(require("./RowRenderer"));

var _SortableHeaderRow = _interopRequireDefault(require("./SortableHeaderRow"));

require("./table.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var TableDesktop = /*#__PURE__*/_react["default"].memo( /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _columns$find;

  var children = props.children,
      disableHeader = props.disableHeader,
      disableReorderColumns = props.disableReorderColumns,
      columnReorderHelperClass = props.columnReorderHelperClass,
      rowHeight = props.rowHeight,
      height = props.height,
      selectable = props.selectable,
      data = props.data,
      pageSize = props.pageSize,
      totalRows = props.totalRows,
      selectedRows = props.selectedRows,
      defaultRowHeight = props.defaultRowHeight,
      isInfiniteQuery = props.isInfiniteQuery,
      onRowSelect = props.onRowSelect,
      onAllRowSelect = props.onAllRowSelect,
      onColumnResize = props.onColumnResize,
      onColumnReorder = props.onColumnReorder,
      rowClassName = props.rowClassName,
      selectedRowClassName = props.selectedRowClassName,
      RowRenderer = props.rowRenderer,
      noRowsRenderer = props.noRowsRenderer,
      showRowCount = props.showRowCount,
      rowCountToolTip = props.rowCountToolTip,
      onRowClick = props.onRowClick,
      onRowDoubleClick = props.onRowDoubleClick,
      onRowMouseOut = props.onRowMouseOut,
      onRowMouseOver = props.onRowMouseOver,
      onPageChange = props.onPageChange,
      sort = props.sort,
      sortBy = props.sortBy,
      sortDirection = props.sortDirection,
      rowRendererData = props.rowRendererData;
  var intl = (0, _nicbaseTranslation.useIntl)();

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      scrollbarWidth = _useState2[0],
      setScrollbarWidth = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      checkAll = _useState4[0],
      setCheckAll = _useState4[1]; // variables for pagination
  // save what rows were already loaded and given as initial data, so they won't be refetched


  var _useState5 = (0, _react.useState)(Math.round(data.length / pageSize)),
      _useState6 = _slicedToArray(_useState5, 2),
      pageNumber = _useState6[0],
      setPageNumber = _useState6[1];

  var _useState7 = (0, _react.useState)(true),
      _useState8 = _slicedToArray(_useState7, 2),
      loadMore = _useState8[0],
      setLoadMore = _useState8[1];

  var _useState9 = (0, _react.useState)(new Array(data.length).fill(true)),
      _useState10 = _slicedToArray(_useState9, 2),
      loadedRowsMap = _useState10[0],
      setLoadedRowsMap = _useState10[1];

  var gridRef = (0, _react.useRef)(); // use big default height to enable scroll bar in first measurement cycle

  var cellCache = (0, _react.useMemo)(function () {
    return new _reactVirtualized.CellMeasurerCache({
      fixedWidth: true,
      defaultHeight: defaultRowHeight
    });
  }, [defaultRowHeight]); // map columns for simple representation

  var columns = (0, _react.useMemo)(function () {
    var childColumns = _react.Children.toArray(children).map(function (column) {
      var _column$props = column.props,
          dataKey = _column$props.dataKey,
          width = _column$props.width,
          columnData = _column$props.columnData,
          label = _column$props.label;
      return {
        dataKey: dataKey,
        width: width,
        columnData: columnData,
        label: label
      };
    }); // add selection column as first


    if (selectable) {
      childColumns.unshift({
        dataKey: 'selection',
        width: 50
      });
    }

    return childColumns;
  }, [children, selectable]);

  var loadMoreRows = function loadMoreRows(_ref) {
    var startIndex = _ref.startIndex,
        stopIndex = _ref.stopIndex;

    if (loadMore) {
      // set all rows as already loaded, so they are not considered for additional requests
      setLoadedRowsMap(function (prev) {
        var newLoadedRowsMap = _toConsumableArray(prev);

        for (var i = startIndex; i <= stopIndex; i += 1) {
          newLoadedRowsMap[i] = true;
        }

        return newLoadedRowsMap;
      });
    }

    return new Promise(function (resolve) {
      if (loadMore) {
        onPageChange({
          pageNumber: pageNumber,
          pageSize: pageSize,
          done: resolve
        });
        setPageNumber(function (prev) {
          return prev + 1;
        });
      } else {
        resolve();
      }
    });
  };

  (0, _hooks.useDidMount)(function () {
    if (data.length === 0) {
      loadMoreRows({
        startIndex: 0,
        stopIndex: pageSize - 1
      });
    }
  }); // handle data change

  var oldData = (0, _hooks.usePrevious)(data);
  (0, _hooks.useDidUpdate)(function () {
    if (data.length && gridRef.current) {
      var grid = (0, _reactDom.findDOMNode)(gridRef.current); // eslint-disable-line

      var clientWidth = grid.clientWidth || 0;
      var offsetWidth = grid.offsetWidth || 0;
      setScrollbarWidth(offsetWidth - clientWidth);
    }

    if (data.length > 0 && data.length > oldData.length && data.length < pageSize * pageNumber && !isInfiniteQuery) {
      setLoadMore(false);
    } else if (data.length === totalRows && !isInfiniteQuery) {
      // flag to not send any more requests, because end of available data is reached
      setLoadMore(false);
    }
  }, [data, isInfiniteQuery, oldData, pageNumber, pageSize, totalRows]);
  var handleRowSelect = (0, _react.useCallback)(function (_ref2) {
    var index = _ref2.index,
        rowData = _ref2.rowData;
    onRowSelect({
      index: index,
      rowData: rowData,
      checked: !selectedRows.includes(index)
    });
  }, [onRowSelect, selectedRows]);
  var handleAllRowSelect = (0, _react.useCallback)(function (_ref3) {
    var checked = _ref3.checked;
    setCheckAll(checked);
    onAllRowSelect({
      checked: checked
    });
  }, [onAllRowSelect]);
  var handleColumnResize = (0, _react.useCallback)(function (_ref4) {
    var dataKey = _ref4.dataKey,
        deltaX = _ref4.deltaX;
    // get existing column
    var columnForUpdate = columns.find(function (column) {
      return column.dataKey === dataKey;
    });

    if (columnForUpdate) {
      // calculate new width
      var newWidth = Math.max(columnForUpdate.minWidth || 25, columnForUpdate.width + deltaX);
      onColumnResize({
        dataKey: dataKey,
        deltaX: deltaX,
        width: newWidth
      });
    }
  }, [columns, onColumnResize]);
  var handleColumnReorder = (0, _react.useCallback)(function (_ref5) {
    var oldIndex = _ref5.oldIndex,
        potentialNewIndex = _ref5.newIndex;

    if (oldIndex === potentialNewIndex) {
      return;
    }

    var reorderedColumn = columns[oldIndex];
    var columnData = reorderedColumn.columnData,
        dataKey = reorderedColumn.dataKey; // ensure that selection column is always first

    var newIndex = Math.max(potentialNewIndex, selectable ? 1 : 0); // remove reordered column from old array

    var cols = [].concat(_toConsumableArray(columns.slice(0, oldIndex)), _toConsumableArray(columns.slice(oldIndex + 1))); // insert column on new position

    cols.splice(newIndex, 0, columns[oldIndex]); // update columns

    onColumnReorder({
      dataKey: dataKey,
      columnData: columnData,
      oldIndex: oldIndex,
      newIndex: newIndex
    });
  }, [columns, onColumnReorder, selectable]);
  var remeasureCells = (0, _react.useCallback)(function (rowIndex) {
    if (!rowIndex) {
      cellCache.clearAll();
    } else {
      cellCache.clear(rowIndex, 0);
    }
  }, [cellCache]);
  var clearPagination = (0, _react.useCallback)(function () {
    setPageNumber(0);
    setLoadedRowsMap([]);
    setLoadMore(true);
  }, []);
  (0, _react.useEffect)(function () {
    if (typeof ref === 'function') {
      ref({
        remeasureCells: remeasureCells,
        clearPagination: clearPagination
      });
    }
  }, [ref, clearPagination, remeasureCells]);
  var handleTableSort = (0, _react.useCallback)(function (params) {
    remeasureCells();
    sort(params);
  }, [remeasureCells, sort]);
  var renderColumns = (0, _react.useMemo)(function () {
    var columnElements = _react["default"].Children.toArray(children);

    return columns.map(function (column) {
      if (column.dataKey !== 'selection') {
        return /*#__PURE__*/_react["default"].cloneElement(columnElements.find(function (child) {
          return child.props.dataKey === column.dataKey;
        }), _objectSpread({}, column));
      }

      return /*#__PURE__*/_react["default"].createElement(_Column.Column, {
        dataKey: "selection",
        label: /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiCheckbox, {
          className: "justify-center",
          name: "selectAll",
          checked: checkAll,
          label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
            id: "table.selectAll"
          }),
          hideLabel: true,
          onChange: function onChange(checked, event) {
            handleAllRowSelect({
              checked: checked
            });
            event.stopPropagation();
          }
        }),
        width: 50,
        disableReorder: true,
        style: {
          alignItems: 'initial'
        },
        cellRenderer: function cellRenderer(_ref6) {
          var rowIndex = _ref6.rowIndex,
              rowData = _ref6.rowData;
          return /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiCheckbox, {
            name: "selection",
            checked: selectedRows.indexOf(rowIndex) > -1,
            label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
              id: "table.selectRow"
            }),
            hideLabel: true,
            onChange: function onChange(checked, event) {
              handleRowSelect({
                index: rowIndex,
                rowData: rowData,
                checked: checked
              });

              if (!checked && checkAll) {
                setCheckAll(false);
              }

              event.stopPropagation();
            }
          });
        }
      });
    });
  }, [checkAll, children, columns, handleAllRowSelect, handleRowSelect, selectedRows]);

  var createRow = function createRow(_ref7) {
    var index = _ref7.rowIndex,
        key = _ref7.key,
        parent = _ref7.parent,
        style = _ref7.style;
    var className = rowClassName instanceof Function ? rowClassName({
      index: index
    }) : rowClassName;
    var isSelected = selectedRows.includes(index);

    var rowStyle = _objectSpread(_objectSpread({}, style), {}, {
      paddingRight: scrollbarWidth
    });

    var rowData = data[index]; // use cellMeasurer for dynamic row height

    return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.CellMeasurer, {
      cache: cellCache,
      parent: parent,
      columnIndex: 0,
      rowIndex: index,
      key: key
    }, /*#__PURE__*/_react["default"].createElement(RowRenderer, _extends({
      className: (0, _classnames["default"])(className, _defineProperty({
        'table-row-odd': index % 2 === 0 && !isSelected
      }, selectedRowClassName, isSelected)),
      cellCache: cellCache,
      columns: renderColumns,
      index: index,
      isSelected: isSelected,
      parent: parent,
      onRowClick: onRowClick,
      onRowDoubleClick: onRowDoubleClick,
      onRowMouseOut: onRowMouseOut,
      onRowMouseOver: onRowMouseOver,
      rowData: rowData,
      style: rowStyle
    }, rowRendererData)));
  };

  var isRowLoaded = function isRowLoaded(_ref8) {
    var index = _ref8.index;
    return !!loadedRowsMap[index];
  };

  var tableWidth = columns.reduce(function (prevCol, nextColumn) {
    return prevCol + nextColumn.width;
  }, 0);

  if (selectable) {
    tableWidth += 50;
  }

  var defaultRowCount = /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "table.rowCount"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "row-count-default"
    }, message, ": ", totalRows || data.length);
  });

  var headerColumns = (0, _react.useMemo)(function () {
    return disableHeader ? [] : renderColumns;
  }, [disableHeader, renderColumns]);

  if (!data.length && noRowsRenderer) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "noRowsRenderer"
    }, noRowsRenderer());
  }

  var sortMessageId = sortDirection === 'ASC' ? 'table.sortedAscBy' : 'table.sortedDescBy';
  var sortedColumnLabel = (_columns$find = columns.find(function (column) {
    return column.dataKey === sortBy;
  })) === null || _columns$find === void 0 ? void 0 : _columns$find.label;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "table-wrapper"
  }, showRowCount ? rowCountToolTip || defaultRowCount : null, sortedColumnLabel && /*#__PURE__*/_react["default"].createElement("span", {
    className: "sr-only"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: sortMessageId,
    values: {
      columnLabel: intl.formatMessage({
        id: sortedColumnLabel
      })
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "nic-table"
  }, /*#__PURE__*/_react["default"].createElement(_reactVirtualized.InfiniteLoader, {
    minimumBatchSize: pageSize,
    isRowLoaded: isRowLoaded,
    loadMoreRows: loadMoreRows,
    rowCount: totalRows || Number.MAX_SAFE_INTEGER,
    threshold: pageSize
  }, function (_ref9) {
    var onRowsRendered = _ref9.onRowsRendered;
    return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.AutoSizer, {
      disableWidth: true
    }, function (_ref10) {
      var calculatedHeight = _ref10.height;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: tableWidth,
          height: height || calculatedHeight
        }
      }, !disableHeader && /*#__PURE__*/_react["default"].createElement(_SortableHeaderRow["default"], _extends({}, props, {
        axis: "x",
        helperClass: columnReorderHelperClass,
        lockAxis: "x",
        lockToContainerEdges: true,
        columns: headerColumns,
        onColumnResize: handleColumnResize,
        useDragHandle: true,
        disableReorder: disableReorderColumns,
        onSortEnd: handleColumnReorder,
        sort: handleTableSort
      })), /*#__PURE__*/_react["default"].createElement(_reactVirtualized.Grid, _extends({}, props, {
        ref: gridRef,
        cellRenderer: createRow,
        columnCount: 1,
        columnWidth: tableWidth,
        height: height || calculatedHeight - 65,
        overscanColumnCount: 0,
        overscanRowCount: 10,
        scrollbarWidth: scrollbarWidth,
        rowCount: data.length,
        rowHeight: rowHeight || cellCache.rowHeight,
        rowGetter: function rowGetter(_ref11) {
          var index = _ref11.index;
          return data[index];
        },
        onSectionRendered: function onSectionRendered(_ref12) {
          var rowOverscanStartIndex = _ref12.rowOverscanStartIndex,
              rowOverscanStopIndex = _ref12.rowOverscanStopIndex,
              rowStartIndex = _ref12.rowStartIndex,
              rowStopIndex = _ref12.rowStopIndex;
          return onRowsRendered({
            overscanStartIndex: rowOverscanStartIndex,
            overscanStopIndex: rowOverscanStopIndex,
            startIndex: rowStartIndex,
            stopIndex: rowStopIndex
          });
        },
        width: tableWidth,
        style: {
          overflowX: 'hidden'
        }
      })));
    });
  })));
}));

TableDesktop.propTypes = {
  children: _propTypes["default"].node,
  columnReorderHelperClass: _propTypes["default"].string,
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  disableHeader: _propTypes["default"].bool,
  disableReorderColumns: _propTypes["default"].bool,
  headerClassName: _propTypes["default"].string,
  headerColumnClassName: _propTypes["default"].string,
  headerStyle: _propTypes["default"].shape({}),
  height: _propTypes["default"].number,
  noRowsRenderer: _propTypes["default"].func,
  onColumnReorder: _propTypes["default"].func,
  onColumnResize: _propTypes["default"].func,
  onRowClick: _propTypes["default"].func,
  onRowSelect: _propTypes["default"].func,
  onAllRowSelect: _propTypes["default"].func,
  onRowDoubleClick: _propTypes["default"].func,
  onRowMouseOut: _propTypes["default"].func,
  onRowMouseOver: _propTypes["default"].func,
  onHeaderClick: _propTypes["default"].func,
  onScroll: _propTypes["default"].func,
  onPageChange: _propTypes["default"].func,
  pageSize: _propTypes["default"].number,
  defaultRowHeight: _propTypes["default"].number,
  totalRows: _propTypes["default"].number,
  showRowCount: _propTypes["default"].bool,
  rowCountToolTip: _propTypes["default"].node,
  rowClassName: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].string]),
  selectedRowClassName: _propTypes["default"].string,
  rowRenderer: _propTypes["default"].func,
  rowHeight: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].number]),
  sort: _propTypes["default"].func,
  sortBy: _propTypes["default"].string,
  selectable: _propTypes["default"].bool,
  selectedRows: _propTypes["default"].arrayOf(_propTypes["default"].number),
  scrollToAlignment: _propTypes["default"].string,
  scrollToRow: _propTypes["default"].number,
  sortDirection: _propTypes["default"].oneOf([_reactVirtualized.SortDirection.ASC, _reactVirtualized.SortDirection.DESC]),
  isInfiniteQuery: _propTypes["default"].bool,
  rowRendererData: _propTypes["default"].shape({})
};

var noop = function noop() {};

TableDesktop.displayName = 'TableDesktop';
TableDesktop.defaultProps = {
  data: [],
  //eslint-disable-line
  rowCountToolTip: null,
  columnReorderHelperClass: 'table-header-ordering table-header-column',
  disableHeader: false,
  disableReorderColumns: false,
  headerClassName: 'table-header',
  headerColumnClassName: 'table-header-column',
  rowRenderer: _RowRenderer["default"],
  rowClassName: 'nic-table-row',
  selectedRowClassName: 'table-row-selected',
  scrollToAlignment: 'auto',
  scrollToRow: -1,
  noRowsRenderer: function noRowsRenderer() {},
  onColumnReorder: noop,
  onColumnResize: noop,
  onRowClick: noop,
  onRowSelect: noop,
  onAllRowSelect: noop,
  onRowDoubleClick: noop,
  onRowMouseOut: noop,
  onRowMouseOver: noop,
  onHeaderClick: noop,
  onScroll: noop,
  onPageChange: function onPageChange(_ref13) {
    var done = _ref13.done;
    return done();
  },
  pageSize: 50,
  defaultRowHeight: 200,
  totalRows: null,
  showRowCount: false,
  selectedRows: [],
  sort: noop,
  children: null,
  headerStyle: {},
  height: 0,
  rowHeight: 0,
  sortBy: undefined,
  selectable: false,
  sortDirection: _reactVirtualized.SortDirection.ASC,
  isInfiniteQuery: false,
  rowRendererData: {}
};
var _default = TableDesktop;
exports["default"] = _default;